module.exports = __webpack_public_path__ + "media/images/riders/small/DEFAULT-0fca86feca97caaa2633a5d19158619b.jpg";